import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useUser } from '../auth';
import { isItAccess } from '../constants/Roles';

// Routes an IT Access user is allowed to reach. Everything else redirects to
// the No Permission screen. IT Access exists solely to manage users.
const IT_ACCESS_ALLOWED_PREFIXES = ['/management', '/no-permission', '/settings'];

const isAllowedForItAccess = (path) =>
	IT_ACCESS_ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));

const PrivateRoute = ({ component: Component, ...rest }) => {
	const { isSignedIn, user } = useUser();
	return (
		<Route
			{...rest}
			render={(props) => {
				if (!isSignedIn) return <Redirect to='/login' />;
				// IT Access users are restricted to User Management.
				const path = props.location.pathname;
				if (isItAccess(user) && !isAllowedForItAccess(path)) {
					return <Redirect to='/no-permission' />;
				}
				return <Component {...props} />;
			}}
		/>
	);
};

export default PrivateRoute;
